module.exports = __webpack_public_path__ + "img/HandCuffs_TH.75885930.png";